import React from 'react';

import {
  Wrapper,
  Texts,
  MailContainer,
  SelectContainer,
  IconWMailOpenOutline,
  GlobalStyle,
  Email,
  EmailTitle,
  Section,
} from './styles';

interface Contact {
  info: string;
  selected: boolean;
  selectFunction(name: string): void;
  onkeypress: Function;
  useTwoFactor: boolean;
}

const EmailCard: React.FC<Contact> = ({
  info,
  selected,
  selectFunction,
  onkeypress,
  useTwoFactor,
}) => {
  return (
    <Wrapper
      tabIndex={0}
      className={selected ? 'selected' : ''}
      onClick={() => selectFunction('email')}
      onKeyPress={(e) => onkeypress(e)}
    >
      <GlobalStyle />

      <MailContainer>
        <Section>
          <IconWMailOpenOutline />
          <Texts>
            {useTwoFactor && (
              <EmailTitle>Enviar o código para o e-mail:</EmailTitle>
            )}
            <Email>{info}</Email>
          </Texts>
        </Section>

        <SelectContainer
          selected={selected}
          onClick={() => selectFunction('email')}
        >
          <span />
        </SelectContainer>
      </MailContainer>
    </Wrapper>
  );
};

export default EmailCard;
